"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = require("prop-types");

var _css = _interopRequireDefault(require("@styled-system/css"));

var _system = _interopRequireDefault(require("../../../utils/system"));

var _CardHeader = _interopRequireDefault(require("../CardHeader/CardHeader"));

var _CardBody = _interopRequireDefault(require("../CardBody/CardBody"));

var _CardFooter = _interopRequireDefault(require("../CardFooter/CardFooter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var propTypes = {
  /**
   * The content of the component.
   */
  children: _propTypes.node.isRequired
};
var Card = (0, _system["default"])('div')({
  label: 'Card'
}, (0, _css["default"])({
  backgroundColor: 'white',
  border: '1px',
  borderColor: 'gray.100',
  borderRadius: 'md',
  boxShadow: 'lg',
  boxSizing: 'border-box'
}));
Card.displayName = 'Card';
Card.propTypes = propTypes;
Card.Header = _CardHeader["default"];
Card.Body = _CardBody["default"];
Card.Footer = _CardFooter["default"];
var _default = Card;
exports["default"] = _default;

//# sourceMappingURL=Card.js.map